module.exports = __webpack_public_path__ + "img/coffee-cup.29b7e11b.svg";